import React from "react";

export default function ReturnAndRefundInformationTable({ data }) {
  const table = {
    header: [
      {
        id: 1,
        title: "항목",
      },
      {
        id: 2,
        title: (
          <span>
            반품완료
            <br />
            (신용카드)
          </span>
        ),
      },
      {
        id: 3,
        title: (
          <span>
            반품완료
            <br />
            (무통장입금)
          </span>
        ),
      },
      {
        id: 4,
        title: "계",
      },
    ],
  };
  return (
    <>
      <div className="p-2 bg-primary-blue text-white font-bold">
        반품 환불정보 (반품거부 제외)
      </div>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  colSpan={val?.id === 4 ? 2 : 1}
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border border-[#dddddd]">총 환불건수</td>
              <td className="p-3 border border-[#dddddd]">
                {data?.creditCard?.refunds}
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deposit?.refunds}
              </td>
              <td className="p-3 border border-[#dddddd] text-[#e80000]">
                {data?.system?.refunds}
              </td>

              <td className="p-3 border border-[#dddddd]">건</td>
            </tr>
            <tr>
              <td className="p-3 border border-[#dddddd]">총 결제금액</td>
              <td className="p-3 border border-[#dddddd]">
                {data?.creditCard?.amount}
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deposit?.amount}
              </td>
              <td className="p-3 border border-[#dddddd] text-[#e80000]">
                {data?.system?.amount}
              </td>
              <td className="p-3 border border-[#dddddd]">원</td>
            </tr>
            <tr>
              <td className="p-3 border border-[#dddddd]">총 주문수량</td>
              <td className="p-3 border border-[#dddddd]">
                {data?.creditCard?.total}
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deposit?.total}
              </td>

              <td className="p-3 border border-[#dddddd] text-[#e80000]">
                {data?.system?.total}
              </td>

              <td className="p-3 border border-[#dddddd]">개</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
